import api from '../config/api';

export default {
  getFormResponses: (accountId, { type, pageNumber = 1, pageSize = 20 }) =>
    api.get(`api/v1/accounts/${accountId}/form_responses`, {
      type,
      page_size: pageSize,
      page: pageNumber
    }),
  getFormResponseDetails: (accountId, formId) =>
    api.get(`api/v1/accounts/${accountId}/form_responses/${formId}`),

  getForm: (formId, accountId) =>
    accountId
      ? api.get(`api/v1/forms/${formId}`, { account_id: accountId })
      : api.get(`api/v1/forms/${formId}`),

  submitForm: (accountId, formId, responseFields, surveyId) =>
    api.post(`api/v1/accounts/${accountId}/form_responses`, {
      form_response: {
        form_id: formId,
        input_values: responseFields
      },
      account_id: accountId,
      survey_history_id: surveyId
    }),

  submitPublicForm: (formId, responseFields) =>
    api.post(`api/v1/form_responses`, {
      form_response: {
        form_id: formId,
        input_values: responseFields
      }
    }),

  getFormCategories: (accountId, type) =>
    api.get('api/v1/form_categories', { forms_type: type, account_id: accountId }),

  getPublicFormCategories: type => api.get('api/v1/form_categories', { forms_type: type }),

  reiteration: (accountId, id, comment) =>
    api.post(`api/v1/accounts/${accountId}/form_responses/${id}/reiteration`, {
      form_response_id: id,
      account_id: accountId,
      comment
    }),

  cancelation: (accountId, id, comment) =>
    api.put(`api/v1/accounts/${accountId}/form_responses/${id}/cancelation`, {
      form_response_id: id,
      account_id: accountId,
      comment
    }),
  getImageUploadUrl: () => api.get(`api/v1/form_responses/upload_url`)
};
